/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Box, Divider, LinearProgress, SelectChangeEvent, Typography } from '@mui/material';

import { OrganizationForm, ToolsDetails } from '../../components/custom';
import { useNavigate, useParams } from 'react-router-dom';
import { IOrganization, OrganizationServices } from '../../services/api/organization/OrganizationServices';
import { useAuthContext } from '../../context';
import { CustomAlert } from '../../components/shared';
import { helpers } from '../../services/helpers/helpers';
import { LayoutBase } from '../../layouts';

export const DetailsOrganizations: React.FC = () => {
    const { id } = useParams();
    const { userData } = useAuthContext();
    const navigate = useNavigate();
    const [loadin, setLoadin] = useState<boolean>(false);
    const [error, setError] = useState<boolean>(false);
    const [newForm, setNewForm] = useState<boolean>(true);
    const [alertInfo, setAlertInfo] = useState<{ open: boolean; message: string; severity: 'success' | 'error' | 'warning' | 'info' }>({
        open: false,
        message: '',
        severity: 'success'
    });
    const [sendClick, setSendClick] = useState<boolean>(false);

    useEffect(() => {
        if (id !== 'novo' && id) {
            setLoadin(true);
            fetchData();
            setNewForm(false);
        }
    }, [id]);

    const [data, setData] = useState<IOrganization>({
        nome_fantasia: '',
        registro: '',
        razao_social: '',
        telefone_geral: '',
        unidade_operacional: '',
        atividade_principal: '',
        produto: '',
        cidade: '',
        estado: '',
        pais: '',
        datum: '',
        cep: '',
        fuso_zona: undefined,
        hemisferio: '',
        utm_ns: undefined,
        utm_ew: undefined,
        email_geral: '',
        producao_anual: undefined,
        qtd_empregados: undefined,
        site: '',
        descricao_acesso: '',
        rua: '',
        bairro: '',
        numero: '',
        complemento: '',
    });

    function verify(data: IOrganization): boolean {
        return (
            data.nome_fantasia !== '' &&
            data.registro !== '' &&
            data.razao_social !== '' &&
            data.telefone_geral !== '' &&
            data.unidade_operacional !== '' &&
            data.atividade_principal !== '' &&
            data.produto !== '' &&
            data.cidade !== '' &&
            data.estado !== '' &&
            data.pais !== '' &&
            data.datum !== '' &&
            data.cep !== '' &&
            data.fuso_zona !== undefined && data.fuso_zona !== null &&
            data.hemisferio !== '' &&
            data.utm_ew !== undefined && data.utm_ew !== null &&
            data.utm_ns !== undefined && data.utm_ns !== null
        );
    }

    const fetchData = () => {
        if (id) {
            OrganizationServices.getById(id)
                .then((response) => {
                    if (response instanceof Error) {
                        setAlertInfo({ message: `Erro ao buscar dados! Erro: ${response.message}`, open: true, severity: 'error' });
                    } else {
                        setData({
                            ...response,
                            fuso_zona: response.fuso_zona === 0 ? undefined : response.fuso_zona,
                            utm_ew: response.utm_ew === 0 ? undefined : response.utm_ew,
                            utm_ns: response.utm_ns === 0 ? undefined : response.utm_ns,
                        });
                        setLoadin(false);
                    }
                })
                .catch((error) => {
                    setAlertInfo({ message: `Erro inesperado ao buscar dados! ${error.message || 'Verifique sua conexão.'}`, open: true, severity: 'error' });
                    setLoadin(false);
                });
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type, checked } = e.target;

        let parsedValue: string | number | boolean | undefined = value;

        if (name === 'utm_ew' || name === 'utm_ns') {
            const cleanValue = value.replace(/[^\d.]/g, '');
            parsedValue = cleanValue === '' ? undefined : parseFloat(cleanValue);
        } else {
            switch (type) {
                case 'number':
                    parsedValue = value === '' ? undefined : parseFloat(value);
                    break;
                case 'checkbox':
                    parsedValue = checked;
                    break;
                default:
                    parsedValue = value;
            }
        }

        setData(prevData => ({
            ...prevData,
            [name]: parsedValue
        }));
    };

    const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = event.target;
        setData(prevData => ({
            ...prevData,
            status: checked
        }));
    };

    const handleChangeSelect = (event: SelectChangeEvent) => {
        setData(prevData => ({
            ...prevData,
            id_empresa: event.target.value as string
        }));
    };

    const handleChangeDatum = (event: SelectChangeEvent) => {
        setData(prevData => ({
            ...prevData,
            datum: event.target.value as string
        }));
    };

    const fetchAdress = () => {
        if (data && data.cep && data.cep.replace(/\D/g, '').length === 8) {
            const formattedCep = data.cep.replace(/\D/g, '');
            helpers.getAdress(formattedCep)
                .then((response) => {
                    if (response instanceof Error) {
                        console.log(response.message);
                    } else {
                        setData(prevData => ({
                            ...prevData,
                            rua: response.logradouro || '',
                            bairro: response.bairro || '',
                            cidade: response.localidade || '',
                            estado: response.uf || '',
                            pais: 'Brasil'
                        }));
                    }
                })
                .catch((error) => {
                    console.error('Erro ao buscar endereço:', error);
                });
        } else {
            setAlertInfo({ message: 'CEP inválido ou incompleto para busca.', open: true, severity: 'warning' });
        }
    };

    const handleSave = () => {
        if (sendClick) {
            return;
        }

        setSendClick(true);
        setAlertInfo({ message: '', open: false, severity: 'error' });

        const valid = verify(data);
        setError(!valid);

        if (!valid) {
            setAlertInfo({ message: 'Por favor, preencha todos os campos obrigatórios.', open: true, severity: 'warning' });
            setSendClick(false);
            return;
        }

        const dataToSend = { ...data, cep: data.cep ? data.cep.replace(/\D/g, '') : '' };

        if (userData.nivel === 'adm') {
            if (id === 'novo') {
                OrganizationServices.create(dataToSend as IOrganization)
                    .then((response) => {
                        if (response instanceof Error) {
                            setAlertInfo({ message: `Erro ao salvar! Erro: ${response.message}`, open: true, severity: 'error' });
                            setSendClick(false);
                        } else {
                            setAlertInfo({ message: 'Registro salvo!', open: true, severity: 'success' });
                            setTimeout(() => {
                                navigate('/company_organization');
                            }, 1500);
                        }
                    })
                    .catch((error) => {
                        setAlertInfo({ message: `Erro inesperado ao salvar! ${error.message || 'Verifique sua conexão.'}`, open: true, severity: 'error' });
                        setSendClick(false);
                    });
            } else if (id !== 'novo' && id) {
                OrganizationServices.upgrade(id, dataToSend as IOrganization)
                    .then((response) => {
                        if (response instanceof Error) {
                            setAlertInfo({ message: `Erro ao atualizar! Erro: ${response.message}`, open: true, severity: 'error' });
                            setSendClick(false);
                        } else {
                            setAlertInfo({ message: 'Registro atualizado!', open: true, severity: 'success' });
                            setTimeout(() => {
                                navigate('/company_organization');
                            }, 1500);
                        }
                    })
                    .catch((error) => {
                        setAlertInfo({ message: `Erro inesperado ao atualizar! ${error.message || 'Verifique sua conexão.'}`, open: true, severity: 'error' });
                        setSendClick(false);
                    });
            }
        } else {
            const company_user = userData.id_empresa;
            if (company_user) {
                dataToSend.id_empresa = company_user;
            } else {
                setAlertInfo({ message: 'Sem registro de empresa vinculado ao seu usuário! Não é possível criar/atualizar organização.', open: true, severity: 'error' });
                setSendClick(false);
                return;
            }


            if (id === 'novo') {
                OrganizationServices.create(dataToSend as IOrganization)
                    .then((response) => {
                        if (response instanceof Error) {
                            setAlertInfo({ message: `Erro ao salvar! Erro: ${response.message}`, open: true, severity: 'error' });
                            setSendClick(false);
                        } else {
                            setAlertInfo({ message: 'Registro salvo!', open: true, severity: 'success' });
                            setTimeout(() => {
                                navigate('/company_organization');
                            }, 1500);
                        }
                    })
                    .catch((error) => {
                        setAlertInfo({ message: `Erro inesperado ao salvar! ${error.message || 'Verifique sua conexão.'}`, open: true, severity: 'error' });
                        setSendClick(false);
                    });
            } else if (id !== 'novo' && id) {
                OrganizationServices.upgrade(id, dataToSend as IOrganization)
                    .then((response) => {
                        if (response instanceof Error) {
                            setAlertInfo({ message: `Erro ao atualizar! Erro: ${response.message}`, open: true, severity: 'error' });
                            setSendClick(false);
                        } else {
                            setAlertInfo({ message: 'Registro atualizado!', open: true, severity: 'success' });
                            setTimeout(() => {
                                navigate('/company_organization');
                            }, 1500);
                        }
                    })
                    .catch((error) => {
                        setAlertInfo({ message: `Erro inesperado ao atualizar! ${error.message || 'Verifique sua conexão.'}`, open: true, severity: 'error' });
                        setSendClick(false);
                    });
            }
        }
    };

    const handleDelet = () => {
        if (id !== 'novo' && id) {
            OrganizationServices.delet(id)
                .then((response) => {
                    if (response instanceof Error) {
                        setAlertInfo({ message: `Erro ao deletar! Erro: ${response.message}`, open: true, severity: 'error' });
                    } else {
                        setAlertInfo({ message: 'Registro apagado!', open: true, severity: 'success' });
                        setTimeout(() => {
                            navigate('/company_organization');
                        }, 1500);
                    }
                })
                .catch((error) => {
                    setAlertInfo({ message: `Erro inesperado ao deletar! ${error.message || 'Verifique sua conexão.'}`, open: true, severity: 'error' });
                });
        }
    };

    return (
        <LayoutBase title='Cadastro de Empreendimento'
            tollBar={
                <ToolsDetails
                    showSaveButton={userData.permissoes.includes('add') || userData.permissoes.includes('edit')}
                    showDeletButton={userData.permissoes.includes('remove')}
                    onClickSave={handleSave}
                    onClickDelet={handleDelet}
                    disableSave={sendClick}
                />
            }
        >
            <Box>
                {loadin ? <LinearProgress /> :
                    <Box>
                        <Box width={'100%'} display={'flex'} flexDirection={'column'}>
                            <Typography variant='h5'>{data?.nome_fantasia ? data.nome_fantasia : 'Novo Empreendimento'}</Typography>
                            <Divider />
                        </Box>
                        <Box>
                            <OrganizationForm
                                data={data}
                                handleChange={handleChange}
                                fetchAdress={fetchAdress}
                                error={error}
                                newForm={newForm}
                                handleSwitchChange={handleSwitchChange}
                                handleChangeSelect={handleChangeSelect}
                                handleChangeDatum={handleChangeDatum}
                            />
                        </Box>
                    </Box>
                }

                {alertInfo.open &&
                    <CustomAlert
                        severity={alertInfo.severity}
                        message={alertInfo.message}
                    />
                }
            </Box>
        </LayoutBase>
    );
};